import "./UserProfile.css";
import { useSelector } from "react-redux";
import { AppState } from "../../store/configureStore";
import { EditUserDetails } from "./EditUserDetails";
import { ChangePassword } from "./ChangePassword";
import { useEffect, useState } from "react";
import { isLocalLoginEnabledForUser } from "../../services/userService";

export const UserProfile = () => {
    const [localLoginEnabled, setLocalLoginEnabled] = useState<boolean>();
    const user = useSelector((state: AppState) => state.user);

    useEffect(() => {
        if (!user.guid) return;

        isLocalLoginEnabledForUser(user.guid).then(enabled => {
            setLocalLoginEnabled(enabled);
        });
    }, [user]);

    return (
        <div id="container-userProfile" className="user-page-container">
            <div id="page-title-userProfile-div" className="user-page-title tsc-blue">
                <h1 id="page-title">User profile</h1>
            </div>
            <div id="content-userProfile" className="user-page-content">
                <EditUserDetails user={user} />
                {localLoginEnabled && <ChangePassword user={user} />}
            </div>
        </div>
    );
};
